module.exports = {
	"classes": [
		"subscription-center-page"
	],
	"title": "Subscription Center",
	"metas": {
		"description": ""
	},
	"opengraph": {
		"og:title": "",
		"og:description": "",
		"og:url": "https://auth0.com/subscription-center",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "",
		"twitter:description": "",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/subscription-center/data/metadata.json
// module id = 1144
// module chunks = 0